<template>
  <div class="member-account-cell">
    <div class="member-account-cell__container">
      <div class="member-account-cell__left" v-if="vipLevel !== null && showVipTag">
        <el-tag size="mini" class="member-account-cell__vip" :type="tagType">
          {{ vipText }}
        </el-tag>
      </div>
      <div class="member-account-cell__right">
        <el-button v-if="clickable" type="text" size="mini" class="member-account-cell__name-btn" @click="handleClick">
          {{ displayUsername }}
        </el-button>
        <span v-else class="member-account-cell__name-text">{{ displayUsername }}</span>
        <div class="member-account-cell__uid">{{ uidText }}</div>
      </div>
    </div>

    <MemberDetailDialogV2
      v-if="enableDetailDialog && detailDialogVisible && clickable"
      :visible.sync="detailDialogVisible"
      :member-uid="detailMemberUid"
      :user-info="detailUserInfo"
      :default-detail-tab-type="defaultDetailTabType"
    />
  </div>
</template>

<script>
import { computed, defineComponent, ref, watch } from 'vue'
import MemberDetailDialogV2 from '@/pages/admin/member/components/ManageDetailDialogV2.vue'

export default defineComponent({
  name: 'MemberAccountCell',
  components: {
    MemberDetailDialogV2,
  },
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
    username: {
      type: [String, Number],
      default: '',
    },
    uid: {
      type: [String, Number],
      default: '',
    },
    vipLevel: {
      type: [String, Number],
      default: null,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
    showVipTag: {
      type: Boolean,
      default: true,
    },
    tagType: {
      type: String,
      default: 'warning',
    },
    uidPrefix: {
      type: String,
      default: '',
    },
    fallbackText: {
      type: String,
      default: '--',
    },
    enableDetailDialog: {
      type: Boolean,
      default: true,
    },
    defaultDetailTabType: {
      type: String,
      default: 'overview',
    },
    tagPrefix: {
      type: String,
      default: 'VIP',
    },
  },
  setup(props, { emit }) {
    const detailDialogVisible = ref(false)

    const displayUsername = computed(() => {
      const value = props.username
      return value == null || value === '' ? props.fallbackText : String(value)
    })

    const uidText = computed(() => {
      const value = props.uid
      const normalized = value == null || value === '' ? props.fallbackText : String(value)
      return `${props.uidPrefix}${normalized}`
    })

    const vipText = computed(
      () => `${props.tagPrefix}${props.vipLevel == null || props.vipLevel === '' ? 0 : props.vipLevel}`
    )
    const detailMemberUid = computed(() => props.row?.uid ?? '')
    const detailUserInfo = computed(() => {
      return {
        ...props.row,
        username: props.username,
        uid: props.uid,
        vip_level: props.vipLevel,
      }
    })

    const handleClick = () => {
      emit('click')
      emit('detail', props.row)
      if (props.enableDetailDialog) {
        detailDialogVisible.value = true
      }
    }

    watch(
      () => detailDialogVisible.value,
      newVal => {
        if (!newVal) {
          emit('detail-closed')
        }
      }
    )

    return {
      detailDialogVisible,
      displayUsername,
      uidText,
      vipText,
      detailMemberUid,
      detailUserInfo,
      handleClick,
    }
  },
})
</script>

<style lang="scss" scoped>
.member-account-cell {
  width: 100%;

  &__container {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }

  &__left {
    width: 42px;
    min-width: 42px;
    // position: relative;
    min-height: 20px;
  }

  &__vip {
    font-size: 12px;
    color: #909399;
    line-height: 1.3;
    position: absolute;
    top: 0;
    left: 0;
  }

  &__right {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    min-width: 0;
  }

  &__name-btn {
    padding: 0;
    height: auto;
  }

  &__name-text {
    padding: 0;
    height: auto;
  }

  &__uid {
    color: #909399;
  }
}
</style>
